export const DASHBOARD = '/'
export const VISITED = '/visited'
export const TOVISIT = '/tovisit'
export const COUNTRY = '/country/:name'
export const LOGIN = '/login'
export const SIGNUP = '/signup'
export const NOT_FOUND = '/notfound'